/**
 * Created by hp on 2017/8/9.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios'

class MainRecommendBar extends Component {
    constructor() {
        super()
        this.state = {
            initData: false,
            icon:[]
        }
    }

    componentDidMount() {
        axios.get('/api/index/quick_entry_list').then(res => {
           if (res.data.code === 0 ) {
               this.setState({
                   icon: res.data.data.quick_entries,
                   initDate: true
               })
           }
        })
    }

    render() {
        const {icon, initDate} = this.state;
        return initDate && icon.length!==0 ? (
            <div className='main-recommend-bar'>
                {icon.map(v => (
                    <div className="recommend__bar-item" onClick={() => window.location = v.link } key={v.name}>
                        <div className="bar__item-icon">
                            <img src={v.icon} alt=""/>
                        </div>
                        <div className="bar__item-text">
                            {v.name}
                        </div>
                    </div>)
                )}
            </div>
        ) : null
    }
}

export default connect((state) => ({
    account: state.main.account,
}))(MainRecommendBar)



// WEBPACK FOOTER //
// ./src/components/main/MainRecommendBar.js